export default __webpack_public_path__ + "static/media/useradd-11.1ed5632b.svg";